import { StyleSheet } from 'react-native';
import theme from '@/config/theme';
import { isPatientApp } from '@/config/constants';

export const styles = StyleSheet.create({
  isUpsideDown: {
    transform: [{ scaleY: -1 }, { scaleX: -1 }],
  },
  headerRight: {
    flexDirection: 'row',
    width: '100%',
    columnGap: theme.spacings.sm,
  },
  headerRightPatient: {
    justifyContent: 'flex-end',
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  titleText: {
    fontSize: isPatientApp ? theme.fontSizes['2xl'] : theme.fontSizes.lg,
    fontWeight: '600',
  },
  headerTitleIndent: {
    marginLeft: theme.spacings.md,
  },
  skipButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2,
    width: 150,
    justifyContent: 'flex-end',
  },
  skipTitle: {
    fontSize: theme.fontSizes.lg,
    top: -1,
    fontWeight: '600',
  },
});
